import React, { useRef } from 'react';
import { PropTypes } from 'prop-types';
import { useCurrentEmployeeId } from 'common/contexts/CurrentEmployeeContext';
import { PrimaryButton } from 'common/TailwindComponents';
import { useAcceptServiceAuthorization } from '../hooks/useUpdateServiceAuthorization';
import ServiceAuthorizationFormModal from './modals/ServiceAuthorizationFormModal';

const AcceptServiceAuthorizationButton = ({ authorization }) => {
  const modalRef = useRef();
  const currentEmployeeId = useCurrentEmployeeId();
  const acceptAuthorization = useAcceptServiceAuthorization();

  const openModal = () => {
    modalRef.current.openDialog();
  };

  const handleSubmit = async (formData) => {
    try {
      await acceptAuthorization({
        authorization,
        reviewer: currentEmployeeId,
        ...formData,
      });
    } catch (error) {
      // Prevent unhandled error - toast notification is shown by hook's onError callback
    }
  };

  return (
    <>
      <PrimaryButton
        ariaLabel="accept authorization request"
        dataTestId="accept-authorization-button"
        icon="CheckCircle"
        label="Accept"
        onClick={openModal}
        primary
      />

      <ServiceAuthorizationFormModal
        authorization={authorization}
        modalRef={modalRef}
        title={`Accept Authorization Request #${authorization.short_id}`}
        confirmLabel="Accept"
        description={
          'Accepting this request will send the referral to the recipient organization. ' +
          'Any changes you make to the authorized amount will be reflected in the referral.'
        }
        showRequestDetails
        dataTestId="accept-auth-request-dialog"
        confirmButtonTestId="accept-auth-request-dialog-confirm-button"
        initialValuesPrefix="requested"
        onSubmit={handleSubmit}
      />
    </>
  );
};

AcceptServiceAuthorizationButton.propTypes = {
  authorization: PropTypes.shape({
    fee_schedule_program: PropTypes.shape({
      fee_schedule: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }),
    }).isRequired,
    requested_cents: PropTypes.number,
    requested_starts_at: PropTypes.string.isRequired,
    requested_ends_at: PropTypes.string.isRequired,
    requested_unit_amount: PropTypes.number,
    short_id: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    case: PropTypes.shape({
      person: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }),
    }),
    clinical_modifications: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        code: PropTypes.string.isRequired,
      }),
    ),
  }).isRequired,
};

export default AcceptServiceAuthorizationButton;
